import Config from '@/config'

const ServiceHelper = {
	data() {
		return {
			pageHasMore: false,
			pageNumber: Config.DEFAULT_PAGE_NUMBER,
			pageSize: Config.DEFAULT_PAGE_ITEMS,
		}
	},
	computed: {
		loadAllParams() {
			return {
				page: -1,
				page_size: -1,
			}
		},
		loadMoreParams() {
			return {
				page: this.pageNumber,
				page_size: this.pageSize,
			}
		},
	},
	methods: {
		hasMore(data) {
			// Detect if has more according to API response data
			return data.paging.has_more
		},
		loadMore() {
			// Increase page number and load new data
			this.pageNumber = this.pageNumber + 1
			this.loadData()
		},
		loadMoreOnStore() {
			// Increase page number
			this.pageNumber = this.pageNumber + 1
		},
		resetMore() {
			// Reset more flag and page number value
			this.pageHasMore = false
			this.pageNumber = Config.DEFAULT_PAGE_NUMBER
		},
		setAuthorizationToken() {
			// Set the authorization header to axios
			axios.defaults.headers.common.Authorization = 'Bearer ' + this.$store.getters.token
		},
	},
}

export default ServiceHelper



// WEBPACK FOOTER //
// ./src/mixins/ServiceHelper.js